/**
 * Canonical term label stored on `grades.term` and matched by report cards:
 * "Term {1|2|3} {year}".
 */
export function formatGradingTerm(term: number, year: number): string {
  return `Term ${term} ${year}`;
}

const GRADING_TERM_RE = /^Term\s+(\d+)\s+(\d{4})$/i;

/** Parse labels like "Term 1 2025". Returns null if invalid. */
export function parseGradingTerm(value: string): { term: number; year: number } | null {
  const m = GRADING_TERM_RE.exec(value.trim());
  if (!m) return null;
  const term = parseInt(m[1], 10);
  const year = parseInt(m[2], 10);
  if (term < 1 || term > 3 || year < 2020 || year > 2100) return null;
  return { term, year };
}

/** Years shown in grading term dropdowns (calendar year ±1). */
export function defaultGradingTermYears(referenceYear = new Date().getFullYear()): number[] {
  return [referenceYear - 1, referenceYear, referenceYear + 1];
}

/** All "Term n YYYY" strings for terms 1–3 and the given years (chronological). */
export function gradingTermSelectOptions(years: number[]): string[] {
  const sorted = [...new Set(years)].sort((a, b) => a - b);
  const out: string[] = [];
  for (const y of sorted) {
    for (let t = 1; t <= 3; t++) {
      out.push(formatGradingTerm(t, y));
    }
  }
  return out;
}
